import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-47dd48a8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "issue-main" }
const _hoisted_2 = { class: "item" }
const _hoisted_3 = ["alt"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text" }, "Analíticas", -1))
const _hoisted_5 = { class: "item" }
const _hoisted_6 = ["alt"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text" }, "Panel de incidencias", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_row, { gutter: 20 }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, {
          xs: 24,
          sm: 12
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_card, {
              shadow: "hover",
              class: "card",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.go('/issue-monitoring/data-studio')))
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("img", {
                    src: "/img/datab.png",
                    alt: _ctx.$t('app.data_studio'),
                    class: "image"
                  }, null, 8, _hoisted_3),
                  _hoisted_4
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, {
          xs: 24,
          sm: 12
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_card, {
              shadow: "hover",
              class: "card",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.go('/issue-monitoring/samplingpoints')))
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("img", {
                    src: "/img/ico05.png",
                    alt: _ctx.$t('app.issue_monitoring'),
                    class: "image"
                  }, null, 8, _hoisted_6),
                  _hoisted_7
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}